export const seasonEndOffsetInDaysDefault = 30;
